import {
  BasicInfoBeneficiary,
  SupplierServiceForm,
} from './components';

export const stepsServiceSupplier = [
  {
    name: 'SUPPLIERSERVICEFORM',
    label: 'Υπηρεσία',
    Component: SupplierServiceForm,
    id: 0,
  },
  {
    name: 'BASICFORM',
    label: 'Στοιχεία Ωφελούμενου',
    Component: BasicInfoBeneficiary,
    id: 1,
  },
];